import { PagePredictionProperties, PageTypes } from '@shared/types';
export function isPageTags(page) {
    return page.predictions[PagePredictionProperties.type] === PageTypes.tags;
}
